import CoreAPI from "../coreAPI";
import Signup from "../../classes/employerDashboard/signup";
import RegisterUser from "../../classes/employerDashboard/registerUser";

export default function APIAuth(coreAPI: CoreAPI) {
  return {
    async login(credentials: { password: string; email: string }) {
      return coreAPI.call<{
        accessToken: string;
        expiresIn: number;
        idToken: string;
        refreshToken: string;
        tokenType: string;
      }>({
        method: "POST",
        endpoint: "/auth/login",
        body: credentials,
      });
    },
    async forgotPassword(email: string) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/forgotPassword",
        body: {
          email,
        },
      });
    },
    async registerInvitedUser(params: RegisterUser) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/registerInvitedUser",
        body: params,
      });
    },
    async resetPassword(params: { confirmationCode: string; password: string; email: string }) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/resetForgotPassword",
        body: params,
      });
    },
    async signup(params: Signup) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/register",
        body: params.toJSONForAPI(),
      });
    },
    async verifyUser(email: string) {
      return coreAPI.call({
        method: "POST",
        endpoint: "/auth/verifyEmail",
        body: { email },
      });
    },
  };
}
